import * as React from "react";
import {useHomeSelector} from "../../store/slices/home/homeSlice";
import {MediaStrip} from "../common/mediaStrip/MediaStrip";
import {SkeletonStrip} from "../common/skeleton/SkeletonStrip";

import styles from './Home.module.scss';
import {useUserSelector} from "../../store/slices/user/userSlice";

export const Home: React.FC = () => {
    const {isLoading, featuredContent} = useHomeSelector(['isLoading', 'featuredContent']);
    const {recentlyPlayed} = useUserSelector(['recentlyPlayed']);


    const recentlyPlayedStrip = recentlyPlayed && Object.values(recentlyPlayed).length ?
        <MediaStrip featuredContent={{items: Object.values(recentlyPlayed), name: 'Recently played'}}/>
        : <></>;

    return (
        <div className={styles.content}>
            {recentlyPlayedStrip}
            {isLoading ?
                <>{[0, 1, 2].map(i => <SkeletonStrip key={i} />)}</>
                : (featuredContent || []).map(featuredContent =>
                    <MediaStrip
                        key={featuredContent.id}
                        featuredContent={featuredContent}/>
                )}
        </div>
    );
}
